// API MOCK -> TODO: AXIOS AND REAL API
const CompanyNames = new Promise((resolve, reject) => {
    const companyNames = [
        {
            key: 1,
            value: 'MatrexPol',
            name: 'MatrexPol'
        },
        {
            key: 2,
            value: 'FastBud',
            name: 'FastBud'
        },
        {
            key: 3,
            value: 'OmniPol',
            name: 'OmniPol'
        },
        {
            key: 4,
            value: 'DKKW',
            name: 'DKKW'
        },
        {
            key: 5,
            value: 'ManPol',
            name: 'ManPol'
        },
    ];

    setTimeout(() => {
        resolve(companyNames);
    }, 1000);
});

export {CompanyNames};
